import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Location: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 48 48"
    {...props}
  >
    <style>{'.st1{fill:#002677}.st2{fill:#ff612b}'}</style>
    <g>
      <g>
        <path
          className="st1"
          d="M35.7657,26.6022h-0.0006c1.5257-2.2618,2.4166-4.987,2.4166-7.9204C38.1818,10.8494,31.8325,4.5,24,4.5     c-7.8325,0-14.1818,6.3494-14.1818,14.1818c0,2.9335,0.8909,5.6587,2.4166,7.9204h-0.0006L24,43.5l11.7614-16.8917     L35.7657,26.6022z"
        />
        <g>
          <path
            className="st2"
            d="M32.2727,18.6701c0,4.5688-3.7039,8.2727-8.2727,8.2727c-4.5689,0-8.2727-3.7039-8.2727-8.2727      c0-4.569,3.7039-8.2728,8.2727-8.2728C28.5688,10.3973,32.2727,14.1011,32.2727,18.6701z"
          />
        </g>
      </g>
    </g>
  </Box>
)
export default Location
